import type { ListingDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import axios from 'axios';

export type DuplicateListingsForAgentType = JsonObject<{
  count: number;
  data: { _id: string; to: ListingDoc; from: ListingDoc; id: string }[];
}>;

const getDuplicateListingsForAgent = async () => {
  const { data } = await axios.get<DuplicateListingsForAgentType>(
    `/listing/duplicates/agent`,
  );
  return data.data;
};

export default getDuplicateListingsForAgent;
